import React, { useEffect, useState } from "react";

import Shell from "../layout/Shell";
import { api, formatApiError } from "../lib/api";
import { EmptyState, ErrorBanner, LoadingCard, Pill } from "../lib/ui";

export default function Audiences() {
  const [state, setState] = useState({ loading: true, error: null, audiences: [], selected: null, insights: [] });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await api.get("/audiences");
        const list = res.data.audiences || [];
        if (list.length > 0) {
          const detail = await api.get(`/audiences/${list[0].id}`);
          if (cancelled) return;
          setState({
            loading: false, error: null,
            audiences: list,
            selected: detail.data.audience,
            insights: detail.data.insights,
          });
        } else if (!cancelled) {
          setState({ loading: false, error: null, audiences: [], selected: null, insights: [] });
        }
      } catch (e) {
        if (!cancelled) setState((s) => ({ ...s, loading: false, error: formatApiError(e) }));
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const { selected, insights } = state;

  return (
    <Shell title="Audiences">
      <div className="bo-eyebrow">Foundation</div>
      <h1 className="bo-serif" style={{ fontSize: 34, lineHeight: 1.1, letterSpacing: "-0.02em", margin: "6px 0 22px" }} data-testid="audiences-title">
        Audiences
      </h1>

      <ErrorBanner error={state.error} />
      {state.loading && <LoadingCard />}

      {selected && (
        <div className="bo-card" data-testid="audience-card">
          <div className="bo-eyebrow">Audience</div>
          <h2 className="bo-card-title" data-testid="audience-name">{selected.name}</h2>
          <p className="bo-card-lede">{selected.description}</p>

          <div className="bo-eyebrow" style={{ marginTop: 20, marginBottom: 10 }}>Insights ({insights.length})</div>
          {insights.length === 0 ? <EmptyState title="No insights yet" description="Add pain, motivation, and objection insights to power generation." /> : (
            <div style={{ display: "grid", gap: 10 }} data-testid="insights-list">
              {insights.map((i) => (
                <div
                  key={i.id}
                  style={{
                    padding: "12px 14px",
                    borderLeft: "3px solid var(--bo-accent)",
                    background: "var(--bo-panel-alt)",
                    borderRadius: "var(--bo-radius-sm)",
                  }}
                  data-testid={`insight-${i.category}`}
                >
                  <div style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 4 }}>
                    <Pill tone="muted">{i.category.replace("_", " ")}</Pill>
                    <span style={{ fontSize: 11, color: "var(--bo-muted)", letterSpacing: "0.1em", textTransform: "uppercase", fontWeight: 700 }}>
                      confidence: {i.confidence}
                    </span>
                  </div>
                  <div>{i.statement}</div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {!state.loading && !selected && (
        <EmptyState title="No audiences yet" description="Once seeded, audiences appear here." />
      )}
    </Shell>
  );
}
